export const Pokedex: import('../../../sim/dex-species').ModdedSpeciesDataTable = {
	shiftry: {
		inherit: true,
		abilities: { 0: "Chlorophyll", 1: "Early Bird", H: "Pickpocket" },
	},
	piplup: {
		inherit: true,
		abilities: { 0: "Torrent", H: "Defiant" },
	},
	prinplup: {
		inherit: true,
		abilities: { 0: "Torrent", H: "Defiant" },
	},
	empoleon: {
		inherit: true,
		abilities: { 0: "Torrent", H: "Defiant" },
	},
};
